<template>
    <div id="institutionAdmin">

        <div class="header">
            <!-- 面包屑导航 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>教培机构列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 搜索和添加 -->
        <div class="searchBox">
            <el-form :inline="true" style="margin-top: 20px;">
                <el-form-item>
                    <el-input size="small" v-model="keywords" placeholder="请输入用户姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size="small" v-model="keywords2" placeholder="请输入联系方法"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="btnSearch">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="content">
            <!--列表-->
            <el-table size="small" :data="institutionList" highlight-current-row border element-loading-text="拼命加载中"
                style="width: 100%;" height="100%" v-horizontal-scroll>

                <el-table-column align="center" show-overflow-tooltip prop="name" label="机构名称" width="160">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="contactName" label="联系人姓名" width="160">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="contactPhone" label="手机号码" width="160">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="address" label="所在城市" width="160">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="addressDetail" label="地址详情" width="160">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="type" label="培训机构课程" width="160">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="content" label="培训机构基本情况" width="160">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="rejectReason" label="驳回原因" width="160">
                </el-table-column>
                <el-table-column align="center" prop="state" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.auditStatus == 1">审核中</span>
                        <span v-if="scope.row.auditStatus == 2">通过</span>
                        <span v-if="scope.row.auditStatus == 3">审核中</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="120" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="btnOperate(scope.row)">审核</el-button>
                        <!-- <el-button size="mini" type="danger" @click="deleAct(scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <div class="pageTurning">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>

        <!-- 驳回原因 -->
        <el-dialog title="驳回原因" :visible.sync="reasonVisible" width="40%">

            <el-input type="textarea" :rows="5" placeholder="请输入驳回原因" v-model="notReason">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="reasonVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="btnSubmitReason">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import Pagination from '../../components/Pagination'

import { examineApi, institionListApi, institutionalDetails } from '@/api/institution.js'

// 工具栏配置
const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ["link", "image", "video"], // 对于图片上传这是重点
    ["clean"], // remove formatting button
];
export default {
    data() {
        return {
            reasonVisible: false,
            institutionList: [], //机构列表
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            pages: 0,
            temporary_obj: '',
            notReason: '', // 驳回原因
            keywords: '', // 关键字
            keywords2: '', // 联系方式关键字
        }
    },
    created() {
        this.institutionListData()
    },
    // 注册组件
    components: {
        Pagination
    },
    computed: {

    },
    methods: {
        // 点击搜索
        btnSearch() {
            let that = this
            that.pages = 0

            that.institutionListData()
        },
        // 机构列表
        institutionListData() {
            let that = this

            institionListApi({
                contactPhone: that.keywords2,
                contactName: that.keywords,
                page: that.pages * 20
            }).then(res => {

                if (res.code == 200) {
                    that.institutionList = res.data.list
                    that.pageparm.total = parseInt(res.data.count)
                }

            })

        },
        // 操作按钮
        btnOperate(item) {
            let that = this
            that.temporary_obj = item
            this.$confirm('是否审核通过！', '提示', {
                confirmButtonText: '通过',
                cancelButtonText: '驳回',
                distinguishCancelAndClose: true,
                type: 'success'
            }).then((res) => {
                console.log('通过', res)
                that.examineData(2)
            }).catch(action => {
                if (action === 'cancel') {
                    that.reasonVisible = true

                    console.log('驳回')
                } else {
                    console.log('关闭')
                }
            });
        },
        // 审核 
        examineData(status) {
            let that = this

            examineApi({
                auditStatus: status, //  审核状态(1-审核中 2-通过 3-驳回)
                id: that.temporary_obj.id,
                rejectReason: that.notReason, // 驳回原因
            }).then(res => {
                that.reasonVisible = false
                if (res.code == 0) {
                    that.institutionListData()
                } else {
                    this.$message({
                        type: 'info',
                        message: res.msg
                    });
                }
            })

        },
        // 提交审核不通过
        btnSubmitReason() {
            let that = this
            if (!that.notReason) {
                this.$message({
                    type: 'info',
                    message: '请输入驳回原因'
                });
                return false;
            }
            this.$confirm('确定当前操作吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                that.examineData(3)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        // 分页插件事件
        callFather(parm) {
            console.log(parm)
            this.pages = parseInt(parm.currentPage) - 1
            this.institutionListData()
        },
    }

}
</script>

<style>
#institutionAdmin {
    height: 100%;
    display: flex;
    flex-direction: column;
}

#institutionAdmin .header {
    flex: none;
}

#institutionAdmin .searchBox {
    flex: none;
}

#institutionAdmin .content {
    flex: auto;

}

#institutionAdmin .pageTurning {
    flex: none;
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/institution_admin/institution_list.vue